var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfineraIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#infinera_icon_svg__clip0_3951_1711)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "infinera_icon_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 6
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.867 5.066c.832-.945 2.25-1.921 4.131-1.85 2.158.083 3.957.73 5.714 1.131.237-.74.422-1.377.596-1.819.185-.493.411-.832.679-1.058A7.714 7.714 0 007.979.34 7.652 7.652 0 00.867 5.065z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#infinera_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.073 3.771L3.909 10.01l-5.16-8.385L8.925-4.624l5.149 8.395z",
    fill: "#F3981C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "infinera_icon_svg__b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 2,
    width: 4,
    height: 3
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.843 3.391c-.134.329-.257.699-.37 1.11.4.072.801.123 1.202.144 2.508.144 1.439-1.316.966-1.778-.164-.164-.473-.432-.822-.432-.308-.01-.668.216-.976.956z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#infinera_icon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.23 4.13l-3.74 2.303-2.066-3.36L14.165.77l2.066 3.36z",
    fill: "#F3981C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "infinera_icon_svg__c",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 11,
    height: 10
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M.918 11.057c.7 1.51 2.097 2.549 4.08 2.004 2.539-.699 4.08-3.977 5.077-6.803-1.737-.534-3.617-1.325-5.313-1.551a5.858 5.858 0 00-.822-.062c-3.556 0-4.327 3.597-3.022 6.412z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#infinera_icon_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.073 11.16L2.47 18.281l-6.865-11.18L7.208-.02l6.865 11.18z",
    fill: "#F3981C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "infinera_icon_svg__d",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 11,
    height: 11
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.895 6.032c-.935.945-2.312.884-3.874.493-.771 3.833-1.532 8.642-5.612 8.745a7.823 7.823 0 002.56.431 7.688 7.688 0 007.255-10.224 1.446 1.446 0 01-.329.555z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#infinera_icon_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.208 12.906L8.205 20.274.846 8.282 12.84.915l7.368 11.991z",
    fill: "#F3981C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "infinera_icon_svg__clip0_3951_1711"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
export default "data:image/svg+xml;base64,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";
export { SvgInfineraIcon as ReactComponent };